export function shouldShowFeedbackButton({
    isLMSView,
}: {
    isAdminView: boolean;
    isLMSView: boolean;
}) {
    return !isLMSView;
}
